export const LOCAL_STORAGE_KEY = 'lastUserId';
